import clsx from 'clsx'
import { observer } from 'mobx-react-lite'
import { useEffect, useRef, useState } from 'react'
import SoundPlayer from 'react-sdk/SoundPlayer'
import { QCM } from 'react-sdk/activities/QCM'
import classes from './Qcm.module.css'
import QcmChoices from './QcmChoices'
import QrlInput from './QrlInput'
import TimeBar from './TimeBar/TimeBar'

/**
 *
 * @param {object} props
 * @param {QCM} props.instance
 * @returns
 */
const Qcm = ({instance, onReadyToValidate}) => {

  const ctnrRef = useRef(null)

  useEffect(() => {

    if(instance.Type === "qrl") return

    onReadyToValidate(instance.selectedChoices.length > 0)

  }, [instance.selectedChoices]);

  useEffect(() => {

    if(instance.Type !== "qrl") return

    onReadyToValidate(instance.QrlAnswer.length > 0)
  }, [instance.QrlAnswer]);

  return (
    <div className={classes.QCM} ref={ctnrRef}>
      {(instance.Type === "question" ||  instance.Type === "qcm" ||  instance.Type === "QCM") &&
      <QcmChoices qcm={instance}  />}

      {instance.Type === "qrl" &&
      <QrlInput qcm={instance} />}
    </div>
  )
}


export default observer(Qcm)